export default __webpack_public_path__ + "static/media/group77-mobile.cf1ad166.png";